import { AcumaticaRequestOptions } from './../acumatica.service';
import { AcumaticaService } from '../acumatica.service';
import { AcumaticaEntity, AcumaticaEntityService } from './acumatica-entity';
import { Acumatica, AcumaticaFieldFormat } from '../acumatica-field-decorator';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PreAllocationDetail } from './Shipment.service';
import { InventorySource } from './OrderPicking.service';

@Injectable({
    providedIn: 'root'
})
export class InventoryCheckService extends AcumaticaEntityService {
    constructor(acumatica: AcumaticaService) {
        super(acumatica, 'StockChecks', StockCheckInquiry);
    }

    getStockChecks(options?: AcumaticaRequestOptions): Observable<StockCheckInquiry> {
        let inquiry = new StockCheckInquiry();

        if (options === undefined) options = {};
        options = {
            ...{
                expand: 'StockChecksDetails'
            },
            ...options
        };

        return super.putEntity(inquiry, {
            ...{ loader: "Getting Stock Check Requests" },
            ...options
        });
    }
}

export class StockCheckDetail extends AcumaticaEntity {
    @Acumatica() WarehouseID!: string;
    @Acumatica() LocationID!: string;
    @Acumatica() InventoryID!: string;
    @Acumatica() LotSerialNbr!: string;
    @Acumatica() LotSerialHash!: string;
    @Acumatica() Requestor?: string;
    @Acumatica() QtyOnHand?: number;
    @Acumatica() QtyAvailable?: number;
    @Acumatica({ format: AcumaticaFieldFormat.Date }) RequestDate?: Date;

    source?: InventorySource;
    get checked(): boolean { return !!this.source?.hasAdjustment; }

    get key(): string { return this.WarehouseID + '/' + this.LocationID + '/' + this.InventoryID + '/' + this.LotSerialNbr; }
}

export class StockCheckInquiry extends AcumaticaEntity {
    @Acumatica({ type: StockCheckDetail, name: 'StockChecksDetails' }) Details!: StockCheckDetail[];

    constructor(inquiry?: Partial<StockCheckInquiry>) {
        super();
        Object.assign(this, inquiry);
    }
}